import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-countdown-clock',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './countdown-clock.component.html',
  styleUrl: './countdown-clock.component.scss'
})


export class CountdownClockComponent {

    @Input() targetDate: Date = new Date('2025-08-31') // Set your target date here
    days: number = 0;
    hours: number = 0;
    minutes: number = 0;
    seconds: number = 0;
    private intervalId: any;
  
    ngOnInit(): void {
      this.updateCountdown();
      this.intervalId = setInterval(() => this.updateCountdown(), 1000);
    }
  
    ngOnDestroy(): void {
      // Clear the interval when the component is destroyed
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }

    }
    
    private updateCountdown(): void {
      const now = new Date().getTime();
      const target = this.targetDate.getTime();
      const difference = target - now;
  
      if (difference > 0) {
        this.days = Math.floor(difference / (1000 * 60 * 60 * 24));
        this.hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        this.minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        this.seconds = Math.floor((difference % (1000 * 60)) / 1000);
      } else {
        // Countdown has ended
        this.days = 0;
        this.hours = 0;
        this.minutes = 0;
        this.seconds = 0;
        clearInterval(this.intervalId);
      }
    }
}
